import { $plans } from './states';
import { fetchPlans } from './effects';

// Fetch plan
$plans.on(fetchPlans.doneData, (_, data) => data);
